import { envConfig } from "@configs/env";

/**
 * Centralized per-region gates and timing for the deposit flow, so the deposit
 * hooks' rollout behavior and tunables live in one place instead of being
 * scattered across hooks.
 */

// ---- Region gates ----

// Brand groups whose deposit status watcher runs with WS + reduced polling
// (instead of pure polling). Consumed by useDepositStatusWatcher.
const RUN_WITH_WS_GROUPS = [
  "phk1",
  "pkk1",
  "ph96g1",
  "phblg1",
  "bdk1",
  "bd96g1",
  "copkzg1",
  "mxkzg1",
  "mx96g1",
  "pk96g1",
  "penkzg1",
];
export const RUN_WITH_WS = RUN_WITH_WS_GROUPS.includes(envConfig.brand.group);

// Brand groups with re-entry deposit-success recovery enabled (useDepositReconciliation
// + the in-flight ledger it consumes). Staged rollout: MX groups first (lowest
// deposit-success coverage); add groups here as each region is validated.
const RECONCILE_ENABLED_GROUPS = ["mxkzg1", "mx96g1"];
export const RECONCILE_ENABLED = RECONCILE_ENABLED_GROUPS.includes(envConfig.brand.group);

// ---- Timing ----

// Deposit status watcher poll cadence and give-up timeout.
export const DEFAULT_POLLING_INTERVAL = 6 * 1000; // 6s (no WS)
export const DEFAULT_POLLING_INTERVAL_WITH_WS = 20 * 1000; // 20s (WS up, avoid spamming)
export const DEFAULT_WATCHER_TIMEOUT = 10 * 60 * 1000; // 10m; reconciliation covers the rest

// Re-entry recovery window: how long a deposit stays in the in-flight ledger, and
// how fresh a completion must be to replay feedback. Same window by construction.
export const INFLIGHT_DEPOSIT_TTL_MS = 30 * 60 * 1000; // 30m
export const COMPLETION_WINDOW_MS = INFLIGHT_DEPOSIT_TTL_MS;

// Per-order recheck debounce in useDepositReconciliation (guards rapid tab-flips).
export const RECHECK_DEBOUNCE_MS = 30 * 1000; // 30s
